import {ICompetition} from '@components/competitions/ICompetitions';
import {createContext, useContext} from 'react';

export const supportedLangs = ['en', 'fa', 'ar'] as const;
export type Gender = 'male' | 'female' | undefined;
export type Lang = typeof supportedLangs[number];
export type PersonalityType = 'artist' | 'peaceful' | 'interaction' | 'servant' | 'searcher';
export type ResultMode = 'pilgrimage' | 'selfKnowledge' | 'services';
type ContextType = {
	competition: ICompetition,
	mission: number,
	setMission: (_value: number) => void,
	lang: string,
	setLang: (_value: Lang) => void,
	results: Array<number>,
	setResults: (_value: Array<number>) => void,
	setPhone: (_value: string) => void,
	phone: string,
	gender: string | undefined,
	setGender: (_value: Gender) => void,
	type: PersonalityType,
	setType: (_value: PersonalityType) => void,
	referralCode: string,
	setReferralCode: (_value: string) => void,
	referrerCode: string | null,
	referrerFrom: string,
	// setSelectedIndices: (_value: number[]) => void,
	// selectedIndices: Array<number>,
};
const CompetitionImamrezaContext = createContext<ContextType>({
	competition: {},
	mission: 0,
	setMission: (_value: number) => {
	},
	lang: 'fa',
	setLang: (_value: Lang) => {
	},
	results: [],
	setResults: (_value: Array<number>) => {
	},
	phone: '',
	setPhone: (_value: string) => {
	},
	gender: undefined,
	setGender: (_value: string | undefined) => {
	},
	type: 'artist',
	setType: (_value: string) => {
	},
	referrerCode: '',
	referralCode: '',
	setReferralCode: (_value: string) => {
	},
	referrerFrom: '',
	// setSelectedIndices: (_value: number[]) => {
	// },
	// selectedIndices: []
});

const useCompetitionImamrezaContext = () => useContext(CompetitionImamrezaContext);
export {
	CompetitionImamrezaContext,
	useCompetitionImamrezaContext
};
